<template>
  <div class="login-page">
    <v-container fill-height>
      <v-layout wrap text-center>
        <v-flex xs12 align-self-center>
          <v-img :src="require('../../assets/img/logo.svg')" height="321" contain @click.native="checkUpdates" />
        </v-flex>
        <v-layout justify-center>
          <v-flex sm6>
            <h4 v-if="showError && error" class="error--text">
              {{ error }}
            </h4>
            <v-form class="mb-5">
              <v-text-field v-model="form.email" data-vv-name="email" type="email" label="Email" :counter="50" required
                dark autofocus />
              <v-text-field v-model="form.password" v-validate="'required'" :error-messages="errors.collect('password')"
                data-vv-name="password" label="Mot de passe" type="password" :counter="50" required dark autofocus />
              <v-flex mt-5>
                <v-btn :loading="isLoading" :disabled="isLoading" color="#006064" ripple rounded large width="200" dark
                  @click="onSubmit">
                  Connexion
                </v-btn>
              </v-flex>
            </v-form>
            <!-- <router-link to="/forgot-password">
              Mot de passe oublié
            </router-link> -->
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";

const bcrypt = require("bcryptjs");

export default {
  name: "LoginPage",

  data() {
    return {
      // Form data
      form: {
        email: "",
        password: "",
      },

      // Loading
      isLoading: false,

      // Errors
      showError: false,
      error: null,
    };
  },

  methods: {
    ...mapActions({
      doLogin: "auth/login",
      getAll: "getAll",
    }),

    // Clear errors
    clearErrors() {
      this.showError = false;
      this.error = null;
    },

    // On submit check validation
    onSubmit() {
      this.clearErrors();
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.login();
        }
      });
    },

    // Check updates
    checkUpdates() {
      console.log("Checking updates....");

      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        for (var i = 0; i < registrations.length; i++) {
          console.log("registration found : asking for update");
          registrations[i].update();
        }
      });
    },

    // Perform login
    async login() {
      this.isLoading = true;

      if (this.isOffline) {
        this.offlineLogin();
      }

      if (this.isOnline) {
        try {
          // Perform Login
          await this.doLogin(this.form);

          // Call getAll action
          await this.getAll();

          // Temp - Redirect after login
          this.$router.push({ name: "projects-list-local" });
        } catch (error) {
          this.isLoading = false;
          this.showError = true;
          if (error.response && error.response.status === 401) {
            this.error = "Mauvais identifiants";
            // return;
          } else {
            this.error = "Une erreur est survenue";
          }
          // console.log(error.message);
        }
      }
    },

    // Offline login handler
    async offlineLogin() {
      try {
        const localUser = await this.$db.user.toCollection().first();

        if (!localUser) throw new Error("Veuillez vous reconnecter a Internet");

        // Compare form object with user hash
        const itMatch = await bcrypt.compare(
          JSON.stringify(this.form),
          localUser.hash
        );

        if (!itMatch) throw new Error("Mauvais identifiants");

        localStorage.setItem("token", localUser.token);
        this.$store.commit("auth/SET_TOKEN", localUser.token);

        this.$router.push({ name: "projects-list-local" });
      } catch (error) {
        this.isLoading = false;
        const notification = {
          message: error.message,
          type: "error",
        };
        this.$store.dispatch("notifications/add", notification);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  height: 100%;
  background: rgb(136, 14, 79);
  background: linear-gradient(20deg,
      rgba(136, 14, 79, 1) 56%,
      rgba(71, 0, 77, 1) 100%);
}
</style>

<style lang="scss">
#app {
  .login-page {
    .container {
      .layout {
        .v-input {
          .v-input__control {
            .v-input__slot {
              .v-text-field__slot {
                label {
                  &.v-label--active {
                    color: #ffffff !important;
                  }
                }

                input {
                  color: white !important;
                }

                input:-webkit-autofill,
                input:-webkit-autofill:hover,
                input:-webkit-autofill:focus,
                input:-webkit-autofill {
                  -webkit-text-fill-color: white !important;
                  -webkit-box-shadow: 0 0 0px 1000px #880e4f inset;
                  box-shadow: 0 0 0px 1000px #880e4f inset;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
